import { curry1 } from './curry1';
export function curry2(fn) {
    function curried(a, b) {
        switch (arguments.length) {
            case 0: return curried;
            case 1: return curry1(function (b) { return fn(a, b); });
            default: return fn(a, b);
        }
    }
    return curried;
}
//# sourceMappingURL=curry2.js.map